export default {
  title: 'Descuentos y formas de pago',
  headers: {
    type: 'Tipo',
    class: 'Clase de dto/cargo',
    description: 'Descripción',
    base: 'Base',
    percent: '(%)',
    amount: 'Importe',
    document: 'nif/cif emisor',
    date: 'Fecha',
    serie: 'Serie-Número'
  }
}
